import { useId, useLayoutEffect } from 'react'

/**
 * 各画面が `calc(100vh - var(--banner-height, 0px))` の形で高さを計算するために参照する。
 */
const BANNER_HEIGHT_CSS_VAR = '--banner-height'

const bannerHeights = new Map<string, number>()

const applyBannerHeight = () => {
  const total = [...bannerHeights.values()].reduce(
    (sum, height) => sum + height,
    0,
  )
  const root = document.documentElement
  if (total === 0) {
    root.style.removeProperty(BANNER_HEIGHT_CSS_VAR)
    return
  }
  root.style.setProperty(BANNER_HEIGHT_CSS_VAR, `${total}px`)
}

/**
 * 表示中のバナーの高さを `--banner-height` に反映する。
 * 複数のバナーが同時に出たときは高さの合計を入れ、各画面がまとめて差し引けるようにする。
 *
 * @param height バナーの高さ（px）。バナーを出していないときは undefined を渡す
 */
export const useBannerHeight = (height: number | undefined) => {
  const id = useId()

  // バナーのぶんだけ各画面が高さを差し引けるようにする（描画前に反映する）
  useLayoutEffect(() => {
    if (height === undefined) return

    bannerHeights.set(id, height)
    applyBannerHeight()

    return () => {
      bannerHeights.delete(id)
      applyBannerHeight()
    }
  }, [id, height])
}
